import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import UserManagement from './pages/UserManagement';
import UserLogin from './pages/UserLogin';
import ChatConsole from './pages/ChatConsole';
import ChatRoom from './pages/ChatRoom';

// Decode a JWT payload and extract the role claim.
function getRoleFromToken(token) {
  try {
    const payload = token.split('.')[1];
    const decoded = JSON.parse(atob(payload));
    return decoded.role || null;
  } catch {
    return null;
  }
}

// Admin-only route guard
function AdminRoute({ children }) {
  const token = localStorage.getItem('adminToken');
  if (!token) return <Navigate to="/admin" replace />;
  const role = getRoleFromToken(token);
  if (role !== 'ADMIN') {
    localStorage.removeItem('adminToken');
    return <Navigate to="/admin" replace />;
  }
  return children;
}

// User route guard (USER or ROOM_OWNER)
function UserRoute({ children }) {
  const token = localStorage.getItem('userToken');
  if (!token) return <Navigate to="/login" replace />;
  const role = getRoleFromToken(token);
  if (role !== 'USER' && role !== 'ROOM_OWNER') {
    localStorage.removeItem('userToken');
    localStorage.removeItem('userRole');
    localStorage.removeItem('username');
    return <Navigate to="/login" replace />;
  }
  return children;
}

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        {/* Admin console */}
        <Route path="/admin" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={
          <AdminRoute><AdminDashboard /></AdminRoute>
        } />
        <Route path="/admin/users" element={
          <AdminRoute><UserManagement /></AdminRoute>
        } />

        {/* User console */}
        <Route path="/login" element={<UserLogin />} />
        <Route path="/chat-console" element={
          <UserRoute><ChatConsole /></UserRoute>
        } />

        {/* Public chat room (link-based access) */}
        <Route path="/chat/:linkToken" element={<ChatRoom />} />

        {/* Default redirect */}
        <Route path="*" element={<Navigate to="/login" replace />} />
      </Routes>
    </BrowserRouter>
  );
}
